const EMAIL_REGEX = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
const MOBILE_REGEX = /^[0-9]{10}$/;

const PASSWORD_REGEX = /^(?=.*.).{8,}$/;
const OTP_REGEX = /^(?=.*\d).{6}$/;
const NUMBER_REGEX = /^\d+$/;
const NUMBER_REGEX_SUPPORTS_EMPTY = /^\d*$/;
const FLOAT_NUMBER_REGEX_SUPPORTS_EMPTY = /^\d*(\.\d*)?$/;
const FLOAT_NUMBER_REGEX = /^\d+(\.\d+)?$/;
const LONG_PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$/\\\[\]{}_&+,:;=?@#|'"~`<>.^*()%!-])[A-Za-z\d$/\\\[\]{}_&+,:;=?@#|'"~`<>.^*()%!-]{8,16}$/;
const PRODUCT_URL_REGEX = /^\/(?:products\/search|(?:products\/categories|products\/brands|product-campaigns)\/[a-z0-9-]+-\d+)$/;

const dynamicProductListUriMapper = {
  product_campaigns: "product-campaigns",
  brands: "brands",
  categories: "categories",
  search: "search",
}


const isNumber = (number, supportsEmpty = false) => {
  return (supportsEmpty ? NUMBER_REGEX_SUPPORTS_EMPTY : NUMBER_REGEX).test(number);
};

const isFloatNumber = (number, supportsEmpty = false) => {
  return (supportsEmpty ? FLOAT_NUMBER_REGEX_SUPPORTS_EMPTY : FLOAT_NUMBER_REGEX).test(number);
};

const isValidWebUrl = (url, supportNonExternal=true) => {
  let regEx = /^https:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=,]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=,]*)$/gm;
  // let regEx = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm;
  return regEx.test(url) && (supportNonExternal || !isInternalWebUrl(url));
};

// function isValidProductUrl({ url, considerWww = false, supportedParams = ["id", "b"] }) {
//   if (!url) return false; // url is required
//
//   const baseUrlInput = "https://uat.jvtests.com";
//
//   // Remove protocol to handle optional www
//   const domainPart = baseUrlInput.replace(/^https?:\/\//, "");
//   const escapedDomain = domainPart.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
//
//   // Optional www prefix
//   const wwwPattern = considerWww ? `(?:www\\.)?` : ``;
//
//   // Optional parameters pattern
//   let optionalParamsPattern;
//   if (supportedParams && supportedParams.length > 0) {
//     optionalParamsPattern = supportedParams.map(p => `${p}=\\d+`).join("|");
//   } else {
//     optionalParamsPattern = `[^&=]+=[^&]+`; // allow all parameters if empty
//   }
//
//   // /products/search route (mandatory query param)
//   const searchRouteRegex = `\\/products\\/search\\?` +
//     `query=\\s*\\S[^&#]*` +                 // mandatory non-empty query
//     `(?:&(?:${optionalParamsPattern}))*$`;  // optional supported params or all if empty
//
//   // Slug-based routes with optional params
//   const slugRouteRegex = `\\/(?:products\\/categories|products\\/brands|product-campaigns)` +
//                          `\\/[a-z0-9-]+-\\d+` +
//                          `(?:\\?(?:${optionalParamsPattern})(?:&(?:${optionalParamsPattern}))*|$)`;
//
//   // Final regex combining everything
//   const finalRegex = new RegExp(
//     `^https:\\/\\/${wwwPattern}${escapedDomain}(?:${searchRouteRegex}|${slugRouteRegex})`
//   );
//
//   return finalRegex.test(url);
// }

export function createProductUrlValidator({ supportedParams = ["brand_ids", "category_ids", "attribute_ids", "price", "size_ids", "color_ids"] } = {}) {
// export function createProductUrlValidator({ supportedParams = [] } = {}) {
  // Escape domain
  const domainPart = (process.env.REACT_APP_DOMAIN ?? "https://jeevee.com").replace(/^https?:\/\//, "");
  const escapedDomain = domainPart.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // Optional parameters pattern
  let optionalParamsPattern
  if (supportedParams && supportedParams.length > 0) {
    optionalParamsPattern = supportedParams
      .map(p => `${p}=\\d+(?:,\\d+)*`)
      .join('|')
  } else {
    optionalParamsPattern = `[^&=]+=[^&]+`
  }

  // /products/search route
 const searchRouteRegex =
  `\\/products\\/search` +
  `\\?(?=[^#]*(?:query=|&query=)\\s*\\S)` +
  `(?:query=[^&]+|${optionalParamsPattern})` +
  `(?:&(?:query=[^&]+|${optionalParamsPattern}))*`;

  // Slug-based routes
  // const slugRouteRegex = `\\/(?:products\\/categories|products\\/brands|product-campaigns)` +
  const slugRouteRegex = `\\/(?:products\\/categories|products\\/brands)` +
                         `\\/[a-z0-9-]+-\\d+` +
                         `(?:\\?(?:${optionalParamsPattern})(?:&(?:${optionalParamsPattern}))*|$)`;

  // Function that returns a validator based on considerWww
  return function isValidProductUrl({ url, considerWww = false, supportsEmpty = false } = {}) {

    if (!url) return supportsEmpty;

    const wwwPattern = considerWww ? `(?:www\\.)?` : ``;

    // Precompiled regex
    // const finalRegex = new RegExp(`^https:\\/\\/${wwwPattern}${escapedDomain}(?:${searchRouteRegex}|${slugRouteRegex})`);
    const finalRegex = new RegExp(`^https:\\/\\/${wwwPattern}${escapedDomain}(?:${searchRouteRegex}|${slugRouteRegex})$`);
    // console.log(finalRegex.test(url));
    // console.log(url);

    return finalRegex.test(url);
  };
}

export const isValidUrlPartWithId= ( url)=>{

  // return /-(\d+)$/.test(url)
  return PRODUCT_URL_REGEX.test(url)


}
export const isFromSameDomain = (url) => {
  try {
    if (url?.startsWith('/')) return true
    const host = new URL(url).host
    const selfUrl = process.env.self ?? "jeevee.com";
    const _selfHost = (new URL(selfUrl).host).replace("www.", "")

    return _selfHost === host
  } catch (e) {
    return false
  }
}

const isInternalWebUrl = (url) => {
  let regEx = /https:\/\/?([\w.-]*\.[\w]*)/;
  const domainMatch = process.env.REACT_APP_DOMAIN.match(regEx)
  if(domainMatch.length <2){
    return false;
  }
  let matchReg = new RegExp(`\^https:\\/\\/(?:www\\.)?${domainMatch[1]}[.]*`, 'gi');

  return matchReg.test(url);
};

const isValidBlogContent = (content) => {
  return content && content.replaceAll("&nbsp;", "").trim();
};

const isValidBlogTable = (tableData) => {
  // return !tableData.data.rows.some((r) => r.some((data) => !data.content.trim() && data.display));
  return !tableData.data.content.some((r) => r.some((data) => !data.trim()));
};

const isValidEmail = (email) => {
  return EMAIL_REGEX.test(email);
};

const isValidPassword = (pass, supportsEmpty = false) => {
  return (supportsEmpty && !pass) || LONG_PASSWORD_REGEX.test(pass);
};

const isValid8CharsPassword = (password, supportsEmpty = false) => {
  return (supportsEmpty && !password) || PASSWORD_REGEX.test(password)
}

const isValidOldPassword = (oldPass, pass, supportsEmpty = false) => {
  return (supportsEmpty && !oldPass) || pass !== oldPass;
};

const isValidConfirmPassword = (confirmPass, pass, supportsEmpty = false) => {
  return (supportsEmpty && !confirmPass) || confirmPass === pass;
};


export {
  isNumber,
  isFloatNumber,
  isValidWebUrl,
  isValidEmail,
  isValidPassword,
  isValidConfirmPassword,
  isValidOldPassword,
  isValidBlogContent,
  isValidBlogTable,
  isInternalWebUrl,
  isValid8CharsPassword
};